import {PartnerSummaryModel} from '../../../../partner/common/api/model/partnerSummary.model';
import {Moment} from 'moment';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {ValueAndLabelModel} from '../../../../common/model/valueAndLabel.model';
import {WithPermissionModel} from '../../../../common/permission/api/entity/withPermission.model';

export class DocumentSummaryModel extends WithPermissionModel {
    id: number;
    partner: PartnerSummaryModel;
    label: string;
    originalFilename: string;
    creationDate: Moment;
    category: LovValueSummary;
    size: number;
    format: ValueAndLabelModel;
    publicUrl: string;
    sticky: boolean;
    templateId: number;
    publicId: string;
    toBeSigned: boolean;
    hasSignature: boolean;
    signUrl: string;
}

export enum DocumentPermission {
    DOCUMENT_PERMISSION_DOWNLOAD = 'DOCUMENT_PERMISSION_DOWNLOAD'
}

export enum DocumentFormat {
    WORD = 'WORD',
    EXCEL = 'EXCEL',
    IMAGE = 'IMAGE',
    PDF = 'PDF',
    STL = 'STL',
    BLEND = 'BLEND',
    OTHER = 'OTHER',
    JSON = 'JSON'
}
